import type { Block } from '@/types/blocks';

/**
 * Uma página "Em branco" cujo conteúdo é só um bloco HTML é tratada como
 * página pura: renderizada num <iframe srcDoc={...}> em vez de
 * dangerouslySetInnerHTML. Isso importa porque <script> inserido via innerHTML
 * nunca executa — é restrição do navegador, não bug do React — então qualquer
 * bloco HTML com JS ficava mudo mesmo publicado. Um iframe com srcDoc cria um
 * documento de verdade, então o script roda. Efeito colateral desejado: essa
 * mesma página vira hospedável como `src` do bloco Iframe em outro lugar.
 */
export function getPureHtmlContent(layout: string | null | undefined, blocks: Block[]): string | null {
  if (layout !== 'blank') return null;
  if (blocks.length !== 1) return null;
  const [only] = blocks;
  return only.type === 'html' ? only.html : null;
}
